import { render } from "./TransferIcon.vue?vue&type=template&id=71e59946"
import script from "./TransferIcon.vue?vue&type=script&lang=js"
export * from "./TransferIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__